import { camelCase } from 'lodash-es';
import Link from 'next/link';

import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';
import { useJobListSortStore } from '@pflegia/ui/hooks/use-sort';
import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import CardWithTopLine from '@pflegia/ui/shared/card-with-top-line';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

import deJobTitles from '@public/locales/de/jobTitles.json';

import { PositionClusterType } from '@shared/constants/homepage-clusters';

type CardsVariantType = {
  cards: PositionClusterType;
  location?: string;
};

const CardsVariant = ({ cards, location }: CardsVariantType) => {
  const { setSort } = useJobListSortStore();

  const categories = Object.keys(cards);

  return (
    <div className='grid gap-3 lg:my-2 lg:grid-cols-3'>
      {categories.map(category => (
        <CardWithTopLine key={category}>
          <p className='my-5 text-2xl font-medium'>{category}</p>
          <ul className='mt-2 list-none'>
            {cards[category].map(jobPosition => {
              const jobTitleKey = camelCase(jobPosition) as keyof typeof deJobTitles;
              const translatedJobTitle = deJobTitles[jobTitleKey] ?? jobPosition;
              const locationParam = location ? `/${normalizeJobsParams(location)}` : '';
              return (
                <li key={jobPosition} className='mt-3'>
                  <Link
                    href={`${JOBS}/${normalizeJobsParams(translatedJobTitle)}${locationParam}`}
                    onClick={() => setSort(PaginationSortField.Salary)}
                    className='text-primary hover:underline'>
                    {translatedJobTitle}
                  </Link>
                </li>
              );
            })}
          </ul>
        </CardWithTopLine>
      ))}
    </div>
  );
};

export default CardsVariant;
